export default {
  nav: {
    home: 'Accueil',
    planning: 'Planning',
    map: 'Carte',
    quotes: 'Soumissions',
    clients: 'Clients',
    properties: 'Propriétés',
    employees: 'Employés',
    teams: 'Équipes',
    payroll: 'Paie',
    messages: 'Messages',
    finances: 'Finances',
    settings: 'Paramètres',
  },
  search: { placeholder: 'Rechercher un client, une adresse, un employé, #ménage…', empty: 'Aucun résultat.', clients: 'Clients', properties: 'Propriétés', employees: 'Employés', jobs: 'Ménages', quotes: 'Soumissions' },
};
